import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService, ThemeService } from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-noti-order-success-config',
  templateUrl: './noti-order-success-config.component.html',
  styleUrls: ['./noti-order-success-config.component.scss']
})
export class AtwNotiOrderSuccessConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  currentViewAll: any = {}; // biến xác định mở rộng tất cả hay theo thuộc tính
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
  ];

  contentFields = [
    { 
      label: 'tieu_de',
      classField: 'noti-order-success__title',
      fields: [{ field: 'content_header_title', label: 'tieu_de_dat_hang_thanh_cong', isLang: true }]
    },
    { 
      label: 'mo_ta',
      classField: 'noti-order-success__desc',
      fields: [{ field: 'content_body_desc', label: 'mo_ta_dat_hang_thanh_cong', isLang: true }]
    },
    { 
      label: 'tieu_de_phan',
      classField: 'noti-order-success__section-title',
      fields: [
        { field: 'content_info_title', label: 'tieu_de_thong_tin_don_hang', isLang: true },
        { field: 'content_product_title', label: 'tieu_de_danh_sach_san_pham', isLang: true }
      ],
    },
    { 
      label: 'tieu_de_muc_thong_tin',
      classField: 'noti-order-success__info-label',
      fields: [
        { field: 'content_info_code_order', label: 'ma_don_hang', isLang: true },
        { field: 'content_info_order_date', label: 'ngay_dat', isLang: true },
        { field: 'content_info_receiver_name', label: 'nguoi_nhan_hang', isLang: true },
        { field: 'content_info_phone', label: 'so_dien_thoai', isLang: true },
        { field: 'content_info_email', label: 'Email', isLang: true },
        { field: 'content_info_payment_method', label: 'cach_thanh_toan', isLang: true },
        { field: 'content_info_shipping_address', label: 'dia_chi_giao_hang', isLang: true }
      ],
    },
    { 
      label: 'tieu_de_muc_danh_sach_san_pham',
      classField: 'noti-order-success__product-meta',
      fields: [
        { field: 'content_product_price', label: 'gia', isLang: true },
        { field: 'content_product_quantity', label: 'so_luong', isLang: true }
      ], 
    },
    { 
      label: 'tieu_de_tong_thanh_toan',
      classField: 'noti-order-success__total-label',
      fields: [{ field: 'content_payment_title', label: 'tieu_de_tong_thanh_toan', isLang: true }]
    },
    { 
      label: 'can_ho_tro_lien_he',
      classField: 'noti-order-success__support',
      fields: [{ field: 'content_contact_support', label: 'can_ho_tro_lien_he', isLang: true }]
    },
    { 
      label: 'so_dien_thoai',
      classField: 'noti-order-success__support-phone',
      fields: [{ field: 'tel_support', label: 'so_dien_thoai', isLang: false }]
    },
    { 
      label: 'don_vi_tien_te',
      classField: '', 
      fields: [{ field: 'currency', label: 'don_vi_tien_te', isLang: false }]
    },
  ];

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public functionService: FunctionService,
    private vhEventMediator: VhEventMediator,
    public themeService: ThemeService,
  ) { }

  ngOnInit(): void {}

  /**
   * Hàm trackBy giúp Angular tối ưu hóa việc render danh sách, 
   * định danh item dựa vào thuộc tính `field` hoặc `_id`.
   */
  trackByEditContentFormat(index: number, item: any) {
    return item.classField;
  }
  trackByEditContent(index: number, item: any) {
    return item.field;
  }
  
  /**
   *Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        // console.log('updateClass', bool);
      })
  }

  /**
   * Hàm update object vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
        // console.log('updateObject', bool);
      })
  }

  /**
   * Hàm update object vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool: any) => {
        // console.log('updateObject', bool);
      })
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(
      this.objectChoosing._id, 
      { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata }
    ).then((bool: any) => {
      // console.log('updateObject', bool);
    })
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false, menu6: false,
    menu7: false, menu8: false, menu16: false, menu17: false
  };
  openMapSub: { [name: string]: boolean } = {
    submenu1: true, submenu2: false
  };

  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach(key => {
      if (key !== value) targetMap[key] = false;
    });
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['noti-order-success']['width'] = event.width + 'px';
    if (event.height) this.class['noti-order-success']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged(
      { status: 'update-object-selected-ruler', code: this.objectChoosing._id }
    );
    this.updateClass();
  }
}
